import get from 'lodash.get';
import React from 'react';

import { getThemeClass } from '../../tools/textTools';
import ProfileCard from '../AboutUs/ProfileCard';
import RichTextConverter from '../Common/RichText/RichTextConverter';
import Accordion from '../Generic/Accordion';
import IconList from '../Generic/IconList';
import LargeCards from '../Generic/LargeCards';
import * as styles from './GroupedContent.module.scss';
import PageSection from './PageSection';
import TestimonialGroup from './TestimonialGroup';
import ThreeUp from './ThreeUp';
import TicketThreeUpSection from './TicketThreeUpSection';
import WhyAttend from './WhyAttend';

const backgrounds = {
  'Light Blue': styles.lightBlue,
  White: styles.white,
  'Dark Grey': styles.darkGrey,
  Grey: styles.grey,
  //'Spark Gradient': styles.sparkGradient,
  'Purple Gradient': styles.purpleGradient,
};
const GroupedContent = ({
  section,
  i,
  fullImage = false,
  wide = false,
  noPad = false,
  forceNewTab = false,
  colorTheme,
}) => {
  const themeClass = getThemeClass(section.colorTheme?.themeName);

  if (section.type === 'Three Up') {
    return (
      <ThreeUp
        wide={wide}
        id={'watchwords'}
        section={section}
        key={i}
        className={backgrounds[section.backgroundColor] || styles.white}
      />
    );
  } else if (section.type === 'Spark Three Up') {
    return <TicketThreeUpSection pageMeta={section} key={i} />;
  } else if (section.type === 'Accordion') {
    return (
      <PageSection slim key={i} data-analytics-section={'faq-accordion'} className={themeClass}>
        <h2 className={styles.accordionHeader}>{section.heading}</h2>
        <RichTextConverter copy={section.sectionCopy} />
        <Accordion
          items={section.content}
          defaultCollapsed={false}
          colorTheme={section.colorTheme?.themeName || colorTheme}
        />
      </PageSection>
    );
  } else if (section.type === 'Icon List') {
    return (
      <PageSection slim key={i}>
        <IconList
          id={'operating-principals'}
          list={get(section, 'content', [])}
          gatsbyImage={section.mainImage?.gatsbyImageData}
          heading={section.title}
          paragraph={get(section, 'sectionCopy')}
        />
      </PageSection>
    );
  } else if (section.type === 'Large Cards') {
    return (
      <LargeCards
        key={i}
        wide={wide}
        fullImage={fullImage || section.type === 'Large Cards - Full Image'}
        section={section}
        noPad={section.backgroundColor === 'White' || noPad}
        className={backgrounds[section.backgroundColor] || styles.white}
        forceNewTab={forceNewTab}
      />
    );
  } else if (section.type === 'Testimonials') {
    return (
      <TestimonialGroup
        key={i}
        testimonials={section.content}
        itemsPerRow={section.itemsPerRow}
        backgroundColor={section.backgroundColor}
      />
    );
  } else if (section.type === 'High-level Info') {
    return <WhyAttend section={section} key={i} />;
  } else if (section.type === 'Profile Cards' || section.type === 'Template Standard') {
    let styleObj = {};
    if (section.type === 'Template Standard') {
      styleObj['--column-amount'] = section.itemsPerRow;
    }

    return (
      <PageSection
        slim
        key={i}
        className={[
          backgrounds[section.backgroundColor || 'Grey'],
          section.type !== 'Profile Cards' ? styles.templateStdProfile : '',
        ].join(' ')}
        data-analytics-section={'profile-cards'}
      >
        <div className={styles.profiles}>
          <RichTextConverter copy={section.sectionCopy} />
          <div className={styles.profileGrid} style={styleObj}>
            {section.content?.map((card, i) => {
              return (
                <ProfileCard
                  accentColor={section.accentColor}
                  name={card.title}
                  image={card.image}
                  copy={card.body}
                  link={card.linkUrl}
                  key={i}
                  className={styles.profileCardOverride}
                />
              );
            })}
          </div>
        </div>
      </PageSection>
    );
  } else {
    return null;
  }

  /*else if (section.type === 'Template Standard') {
    return (
      <PageSection slim key={i} className={styles.grey}>
        <div className={styles.leadership}>
          <RichTextConverter copy={section.sectionCopy} />
          <div className={styles.leadershipGrid}>
            {section.content?.map((card, i) => {
              return <ProfileCard name={card.title} image={card.image} copy={card.body} link={card.linkUrl} key={i} />;
            })}
          </div>
        </div>
      </PageSection>
    );
  }*/
};

GroupedContent.propTypes = {
  // myProp: PropTypes.string.isRequired
};

export default GroupedContent;
